import React, { useState, useEffect } from 'react';
import {Tabs, Tab} from 'react-bootstrap';
import PageTitle from "../../Components/Pagetitle";
import AllTabData from "./Tabs/allTabData";
import { ENDPOINT, KEY } from "config/constants";
import AuthService from "services/auth.service";
import accessHeader from "services/headers/access-header";
import swal from 'sweetalert';


const CardsPage = () => {

    const [content, setContent] = useState([]);
    const [google, setGoogle] = useState([]);
    const [internal, setInternal] = useState([]);
    const [isLoader, setIsLoader] = useState(false);

    const subAdminAllData = async () => {
        await AuthService.getMethod(ENDPOINT.card_user.listing, true,)
        .then((res) => {
            setContent(res.data.data);
            setGoogle(res.data.data.filter(data => ["google"].includes(data.cardSponsor)));
            setInternal(res.data.data.filter(data => ["internal"].includes(data.cardSponsor)));
            setIsLoader(true);
            console.log("google" , res.data.data);
            
        })
        .catch((err) => {
            swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
        });
    };



    const deleteSubAdmin = async (id) => {
        try {
            const res = await AuthService.deleteMethod(`${ENDPOINT.card_user.delete.url}${id}`, true);
            console.log(res.data);
            subAdminAllData();
        } catch (err) {
            swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
        }
    };
    
    


    useEffect(() => {
        subAdminAllData();
    }, []);
    // content,activeContent,InActiveContent

    if (!isLoader) {
        return (
            <div className='loader'>
                <h3>Loading...</h3>
            </div>
        );
    }

    return (
        <>
            <PageTitle title="Cards" />
            <section className={"section"}>
                <Tabs
                    defaultActiveKey="All"
                    className="mb-3"
                >
                    <Tab eventKey="All" title="All">
                        <AllTabData content={content} deleteSubAdmin={deleteSubAdmin} subAdminAllData={subAdminAllData} />
                    </Tab>
                    <Tab eventKey="Active" title="Google">
                    <AllTabData content={google} deleteSubAdmin={deleteSubAdmin} subAdminAllData={subAdminAllData} />
                    </Tab>
                    <Tab eventKey="Inactive" title="Internal">
                    <AllTabData content={internal} deleteSubAdmin={deleteSubAdmin} subAdminAllData={subAdminAllData} />
                    </Tab>
                </Tabs>
            </section>
        </>
    );
};

export default CardsPage;
